"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticHexagonClassName = exports.hexagonSvgTransformStyles = exports.hexagonStyles = exports.hexagonClipPathContainerId = exports.hexagonAvatarClipId = exports.IsoHexagonClipPath = exports.HexagonClipPathPortal = exports.HexagonBorder = exports.HexagonAvatarClipPath = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDom = require("react-dom");
require("./Hexagon.css");
var _useIsBrowser = require("../hooks/useIsBrowser");
var _layout = require("../layout");
var _browser = require("../utils/browser");
var _getBrowserGlobals;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const hexagonClipPathContainerId = 'cds-hexagon-clipPath-container';
exports.hexagonClipPathContainerId = hexagonClipPathContainerId;
const hexagonAvatarClipId = 'cds-hexagon-avatar-clipper';
exports.hexagonAvatarClipId = hexagonAvatarClipId;
const staticHexagonClassName = 'cds-hexagon';
exports.staticHexagonClassName = staticHexagonClassName;
const hexagonStyles = "cds-hexagonStyles-h17xtxd6";

/**
 * We need to mount this to the DOM one time
 * This is currently done in the PortalProvider
 */
exports.hexagonStyles = hexagonStyles;
const HexagonAvatarClipPath = () => {
  // to get scale values use equation 1/x, where x is height or width
  const xScale = 1 / 66;
  const yScale = 1 / 62;
  return /*#__PURE__*/_react.default.createElement("svg", {
    height: "0",
    viewBox: "0 0 66 62",
    width: "0"
  }, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    clipPathUnits: "objectBoundingBox",
    id: hexagonAvatarClipId,
    transform: `scale(${xScale} ${yScale})`
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M63.4372 22.8624C66.2475 27.781 66.2475 33.819 63.4372 38.7376L54.981 53.5376C52.1324 58.5231 46.8307 61.6 41.0887 61.6H24.4562C18.7142 61.6 13.4125 58.5231 10.564 53.5376L2.10774 38.7376C-0.702577 33.819 -0.702582 27.781 2.10774 22.8624L10.564 8.06243C13.4125 3.07687 18.7142 0 24.4562 0H41.0887C46.8307 0 52.1324 3.07686 54.981 8.06242L63.4372 22.8624Z"
  }))));
};
exports.HexagonAvatarClipPath = HexagonAvatarClipPath;
HexagonAvatarClipPath.displayName = 'HexagonAvatarClipPath';

/**
 * Because the hexagon is not symmetrical, we have to get all mathy to scale the border appropriately
 * Note: These values were manually set with my eyeballs
 */
const hexagonSvgTransformStyles = {
  standard: {
    s: {
      transform: `scale(1.1) translateX(-0.3px)`
    },
    m: {
      transform: `scale(1.075) translateX(-0.25px)`
    },
    l: {
      transform: `scaleY(1.075) translateX(-0.25px)`
    },
    xl: {
      transform: `scaleY(1.075) translateX(-0.25px)`
    },
    xxl: {
      transform: `scaleX(1.05) scaleY(1.075) translateX(-0.55px)`
    },
    xxxl: {
      transform: `scaleX(1.05) scaleY(1.075) translateX(-0.55px)`
    }
  },
  offset: {
    s: {
      transform: `scaleX(1.3) scaleY(1.325)`
    },
    m: {
      transform: `scaleX(1.25) scaleY(1.275)`
    },
    l: {
      transform: `scaleX(1.2) scaleY(1.25)`
    },
    xl: {
      transform: `scaleX(1.175) scaleY(1.215)`
    },
    xxl: {
      transform: `scaleX(1.15) scaleY(1.2125) translateX(-0.25px)`
    },
    xxxl: {
      transform: `scaleX(1.125) scaleY(1.2) translateX(-0.25px)`
    }
  }
};
exports.hexagonSvgTransformStyles = hexagonSvgTransformStyles;
const HexagonBorder = /*#__PURE__*/(0, _react.memo)(({
  strokeColor,
  offset,
  size = 'l',
  testID = staticHexagonClassName
}) => {
  const svgTransformStyles = hexagonSvgTransformStyles[offset ? 'offset' : 'standard'][size];
  return /*#__PURE__*/_react.default.createElement(_layout.Box, {
    "aria-hidden": true,
    height: "100%",
    position: "absolute",
    testID: testID,
    width: "100%"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    "data-testid": `${testID}-svg`,
    style: svgTransformStyles,
    viewBox: "-2.25 0 70 62"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M63.4372 22.8624C66.2475 27.781 66.2475 33.819 63.4372 38.7376L54.981 53.5376C52.1324 58.5231 46.8307 61.6 41.0887 61.6H24.4562C18.7142 61.6 13.4125 58.5231 10.564 53.5376L2.10774 38.7376C-0.702577 33.819 -0.702582 27.781 2.10774 22.8624L10.564 8.06243C13.4125 3.07687 18.7142 0 24.4562 0H41.0887C46.8307 0 52.1324 3.07686 54.981 8.06242L63.4372 22.8624Z",
    "data-testid": `${testID}-path`,
    fill: "none",
    stroke: strokeColor,
    strokeLinecap: "round",
    strokeWidth: 1.5,
    vectorEffect: "non-scaling-stroke"
  })));
});
exports.HexagonBorder = HexagonBorder;
HexagonBorder.displayName = 'HexagonBorder';

/**
 * To prevent a flash when the DOM rehydrates and ensure we don't
 * mount the clip path multiple times, we use a Portal for the
 * browser, but mount directly to the dom for our first paint
 * */
const safeDocument = (_getBrowserGlobals = (0, _browser.getBrowserGlobals)()) === null || _getBrowserGlobals === void 0 ? void 0 : _getBrowserGlobals.document;
const HexagonClipPathPortal = /*#__PURE__*/(0, _react.memo)(() => {
  const hexagonClipPathContainer = (0, _react.useMemo)(
  // prevent duplicate portal root
  () => safeDocument === null || safeDocument === void 0 ? void 0 : safeDocument.createElement('div'), []);
  (0, _react.useEffect)(() => {
    const target = safeDocument === null || safeDocument === void 0 ? void 0 : safeDocument.body;

    // prevent duplicate host
    if (safeDocument !== null && safeDocument !== void 0 && safeDocument.getElementById(hexagonClipPathContainerId) || !hexagonClipPathContainer) return undefined;
    hexagonClipPathContainer.id = hexagonClipPathContainerId;
    hexagonClipPathContainer.style.height = '0px';
    hexagonClipPathContainer.style.width = '0px';
    hexagonClipPathContainer.ariaHidden = 'true';

    // Append element to dom
    target === null || target === void 0 ? void 0 : target.appendChild(hexagonClipPathContainer);

    // Avoid removing child from other provider
    // This happens when multiple PortalProvider are defined
    return () => {
      // Remove element from dom
      target === null || target === void 0 ? void 0 : target.removeChild(hexagonClipPathContainer);
    };
  }, [hexagonClipPathContainer]);
  if (!hexagonClipPathContainer) return null;
  return /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react.default.createElement(HexagonAvatarClipPath, null), hexagonClipPathContainer);
});
exports.HexagonClipPathPortal = HexagonClipPathPortal;
HexagonClipPathPortal.displayName = 'HexagonClipPathPortal';
const IsoHexagonClipPath = () => {
  const isBrowser = (0, _useIsBrowser.useIsBrowser)();
  if (!isBrowser) return /*#__PURE__*/_react.default.createElement(HexagonAvatarClipPath, null);
  return /*#__PURE__*/_react.default.createElement(HexagonClipPathPortal, null);
};
exports.IsoHexagonClipPath = IsoHexagonClipPath;
IsoHexagonClipPath.displayName = 'IsoHexagonClipPath';